import { loadStripe } from '@stripe/stripe-js';

const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

if (!STRIPE_PUBLISHABLE_KEY) {
  throw new Error('Missing required environment variable: VITE_STRIPE_PUBLISHABLE_KEY');
}

export const stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

// Price IDs for our subscription plans
export const STRIPE_PRICE_IDS = {
  basic: {
    monthly: import.meta.env.VITE_STRIPE_PRICE_BASIC_MONTHLY,
    annual: import.meta.env.VITE_STRIPE_PRICE_BASIC_ANNUAL,
  },
  professional: {
    monthly: import.meta.env.VITE_STRIPE_PRICE_PROFESSIONAL_MONTHLY,
    annual: import.meta.env.VITE_STRIPE_PRICE_PROFESSIONAL_ANNUAL,
  },
  enterprise: {
    monthly: import.meta.env.VITE_STRIPE_PRICE_ENTERPRISE_MONTHLY,
    annual: import.meta.env.VITE_STRIPE_PRICE_ENTERPRISE_ANNUAL,
  },
} as const;

export type PlanTier = keyof typeof STRIPE_PRICE_IDS;
export type BillingInterval = 'monthly' | 'annual';

// Helper function to get price ID
export const getPriceId = (plan: PlanTier, interval: BillingInterval) => {
  const priceId = STRIPE_PRICE_IDS[plan][interval];
  if (!priceId) {
    throw new Error(`Missing Stripe price ID for plan: ${plan} (${interval})`);
  }
  return priceId;
}; 